var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "-1 -1 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0878 1.33526C10.0577 1.52276 10.0428 1.71027 10.0428 1.89777C10.0428 3.58531 11.4078 4.9496 13.0878 4.9496C13.2753 4.9496 13.4553 4.92785 13.6428 4.89785V10.9497C13.6428 13.4931 12.1428 15.0006 9.59274 15.0006H4.05085C1.50004 15.0006 0 13.4931 0 10.9497V5.40036C0 2.8503 1.50004 1.33526 4.05085 1.33526H10.0878ZM10.2385 5.89537C10.0352 5.87287 9.83349 5.96287 9.71274 6.12788L7.89845 8.47544L5.82015 6.8404C5.69264 6.74289 5.54264 6.70464 5.39263 6.72039C5.24338 6.74289 5.10838 6.82465 5.01762 6.94465L2.79832 9.83297L2.75257 9.90047C2.62507 10.1397 2.68507 10.4472 2.91007 10.613C3.01507 10.6805 3.12758 10.7255 3.25508 10.7255C3.42834 10.733 3.59259 10.6422 3.69759 10.5005L5.58014 8.07718L7.71769 9.68297L7.78519 9.72722C8.0252 9.85472 8.32521 9.79547 8.49771 9.56971L10.6653 6.77289L10.6353 6.78789C10.7553 6.62289 10.7778 6.41288 10.6953 6.22538C10.6135 6.03788 10.4328 5.91037 10.2385 5.89537ZM13.1929 0C14.1904 0 15.0004 0.81002 15.0004 1.80755C15.0004 2.80507 14.1904 3.61509 13.1929 3.61509C12.1954 3.61509 11.3854 2.80507 11.3854 1.80755C11.3854 0.81002 12.1954 0 13.1929 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcome);
export default __webpack_public_path__ + "static/media/outcome.f5e326629febae61be008796a71c81cd.svg";
export { ForwardRef as ReactComponent };